import { MatDateFormats, NativeDateAdapter } from '@angular/material/core';
export class AppDateAdapter extends NativeDateAdapter {
  // override format(date: Date, displayFormat: Object): string {
  //   let day: string = date.getDate().toString();
  //   day = +day < 10 ? '0' + day : day;
  //   let month: string = (date.getMonth() + 1).toString();
  //   month = +month < 10 ? '0' + month : month;
  //   let year = date.getFullYear();
  //   if (displayFormat === 'input') {
  //     return `${day}/${month}/${year}`;
  //   }
  //   return `${month}/${year}`;
  //   // return date.toDateString();

  // // Override how the date is displayed in the input field
  // override format(date: Date, displayFormat: string): string {
  //   if (!date) return '';

  //   // Customize the date format (DD/MM/YYYY)
  //   const day = date.getDate().toString().padStart(2, '0');
  //   const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
  //   const year = date.getFullYear();

  //   return `${day}/${month}/${year}`;
  // }

  // // Override date parsing to handle different formats (Safari compatibility)
  // override parse(value: any): Date | null {
  //   if (!value || typeof value !== 'string') return null;

  //   const parts = value.split('/');
  //   if (parts.length === 3) {
  //     const day = parseInt(parts[0], 10);
  //     const month = parseInt(parts[1], 10) - 1; // Months are 0-based in JS
  //     const year = parseInt(parts[2], 10);

  //     const parsedDate = new Date(year, month, day);
  //     return isNaN(parsedDate.getTime()) ? null : parsedDate;
  //   }

  //   return null;
  // }

  // Override date formatting for input display (DD/MM/YYYY hh:mm AM/PM)
  override format(date: Date, displayFormat: string): string {
    if (!date) return '';

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;

    if (displayFormat === 'datetime') {
      const hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const period = hours >= 12 ? 'PM' : 'AM';
      const formattedHours = hours % 12 || 12; // Convert 24h format to 12h format
      return `${formattedDate} ${formattedHours}:${minutes} ${period}`;
    }
    if (displayFormat === 'input') {
      return formattedDate;
    }
    return `${month}/${year}`;
  }

  // Override date parsing to support Safari compatibility and datetime parsing
  override parse(value: any): Date | null {
    if (!value || typeof value !== 'string') return null;

    const dateTimeParts = value.split(' ');
    const dateParts = dateTimeParts[0].split('/');

    if (dateParts.length === 3) {
      const day = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1;
      const year = parseInt(dateParts[2], 10);

      let hours = 0;
      let minutes = 0;

      if (dateTimeParts.length > 1) {
        const timeParts = dateTimeParts[1].split(':');
        if (timeParts.length === 2) {
          hours = parseInt(timeParts[0], 10);
          minutes = parseInt(timeParts[1], 10);
          const period = dateTimeParts[2]?.toUpperCase();

          if (period === 'PM' && hours < 12) hours += 12;
          if (period === 'AM' && hours === 12) hours = 0;
        }
      }

      const parsedDate = new Date(year, month, day, hours, minutes);
      return isNaN(parsedDate.getTime()) ? null : parsedDate;
    }

    return null;
  }
}
export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'numeric' },
    dateA11yLabel: {
      year: 'numeric', month: 'long', day: 'numeric'
    },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  }
};
// export const APP_DATE_FORMATS: MatDateFormats = {
//   parse: {
//     dateInput: 'DD/MM/YYYY hh:mm A',
//   },
//   display: {
//     dateInput: 'DD/MM/YYYY hh:mm A',
//     monthYearLabel: 'MMM YYYY',
//     dateA11yLabel: 'LL',
//     monthYearA11yLabel: 'MMMM YYYY'
//   }
// };
export const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD/MM/YYYY', // Define how user input should be parsed
  },
  display: {
    dateInput: 'DD/MM/YYYY', // Format shown in input field
    monthYearLabel: 'MMM YYYY', // Format for month/year selection
    dateA11yLabel: 'LL', // Accessibility format
    monthYearA11yLabel: 'MMMM YYYY' // Accessibility format for month/year selection
  }
};
export const APP_NGX_MAT_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY hh:mm A', // Parsing format
  },
  display: {
    dateInput: 'DD/MM/YYYY hh:mm A', // How the input field displays the date
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};
